<template>
  <div class="mc-delivery-track-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle.accordion-4 class="d-flex justify-content-between">
        <h5>{{ 'Informasi Muatan' }}</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-skeleton />
        </template>
      </b-skeleton-wrapper>
      <div v-if="!isLoading" class="mc-delivery-track-sidebar-accordion-item-body">
        <div v-if="!data || data.length === 0" class="text-center">
          {{ '-' }}
        </div>
        <div
          v-for="(item, index) in data"
          v-else
          :key="item.id"
          class="d-flex mc-delivery-track-sidebar-load"
        >
          <div class="mc-sequence">
            {{ index + 1 }}
          </div>
          <div class="mc-delivery-track-sidebar-load-item">
            <div>
              <div class="d-flex justify-content-between">
                <p>
                  <strong>{{ item.product.name }}</strong>
                </p>

                <div v-if="hasTmsColdChainAccess" class="d-flex align-items-center">
                  <p class="mb-0 me-1">{{ displayTemp(item) }}</p>
                  <i class="icon-fill_thermometer"></i>
                </div>
              </div>
              <p>{{ item.product.product_type.name }}</p>
              <p class="mc-delivery-track-sidebar-load-item-note">
                <i class="icon-outline_file-text"></i>
                {{ item.note ? item.note : '-' }}
              </p>
            </div>
            <div>
              <hr />
              <div class="mc-delivery-track-sidebar-load-item-total">
                <p class="text-muted">
                  <i class="mc-icon-total icon-outline_cube"></i>
                  {{ displayValue(item, 'quantity') }}
                  {{ item.uom }}
                </p>
                <p class="text-muted">
                  <i class="mc-icon-total icon-outline_weight"></i>
                  {{ displayValue(item, 'weight') }}
                  {{ 'Kg' }}
                </p>
                <p class="text-muted">
                  <i class="mc-icon-total icon-outline_expand"></i>
                  {{ displayValue(item, 'volume') }}
                  {{ 'Cbm' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatNumber } from '@/helpers/format-number.js'
export default {
  props: {
    data: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
    shipmentType: {
      type: String,
      default: '',
    },
    hasTmsColdChainAccess: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isLoading() {
      return this.loading
    },
  },
  methods: {
    displayValue(item, field) {
      const deliveredKey = `${field}_delivered`
      const pickedKey = `${field}_picked`

      const decimal = 3
      if (this.status === 'Terkirim') {
        return formatNumber(item?.[deliveredKey], decimal) || '-'
      }

      let value = null

      if (item?.[pickedKey]) {
        value = item[pickedKey]
      } else if (item?.[field]) {
        value = item[field]
      } else if (field === 'weight' && item?.total_weight) {
        value = item.total_weight
      } else if (field === 'volume' && item?.total_volume) {
        value = item.total_volume
      }

      return formatNumber(value, decimal) || '-'
    },
    displayTemp(item) {
      const min_temp = item?.min_temperature
      const max_temp = item?.max_temperature

      if (min_temp != null && max_temp != null) {
        return `${min_temp} ~ ${max_temp}°C`
      } else if (min_temp != null) {
        return `≥ ${min_temp}°C`
      } else if (max_temp != null) {
        return `≤ ${max_temp}°C`
      } else {
        return '-'
      }
    },
  },
}
</script>
